import React, { useRef, useCallback, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { FiUser, FiKey } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import logo from 'assets/logo.png';
import Button from 'components/Button';
import Input from 'components/Input';
import ButtonLink from 'components/ButtonLink';

import api from 'services/api';
import { Role } from 'utils/variables';
import { signInSuccess, signFailure } from 'store/modules/auth/actions';
import getValidationErrors from 'services/getValidationErros';
import AppError from 'utils/AppError';

const schema = Yup.object().shape({
  login: Yup.string().required('Campo Obrigatório'),
  senha: Yup.string().required('Campo Obrigatório'),
});

export default function Signin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async ({ login, senha }) => {
      try {
        formRef.current?.setErrors({});
        await schema.validate({ login, senha }, { abortEarly: false });

        setLoading(true);

        const response = await api.post('login', { login, senha });

        if (response?.data) {
          const { token, usuario } = response.data;

          api.defaults.headers.Authorization = `Bearer ${token}`;

          if (usuario.status === 'resetar_senha') {
            toast.warn('Não esqueça de alterar sua senha em Perfil', {
              autoClose: 15000,
            });
          }

          // Persist dados no redux
          localStorage.setItem('authToken', token);
          localStorage.setItem('authUser', JSON.stringify(usuario));

          // Update Redux store
          dispatch(signInSuccess(token, usuario));

          // Redirect conforme role do usuário
          let redirect = '/dashboard';
          switch (usuario.role) {
            case Role.CEDOC:
              redirect = '/arquivamento';
              break;
            case Role.JORN:
              redirect = '/solicitacaochamada';
              break;
            case Role.MKT:
              redirect = '/melhoriadobreak';
              break;
            case Role.EXEC:
              redirect = '/criativos';
              break;
            case Role.PROMO:
            case Role.PROG:
              redirect = '/chamadas';
              break;
          }
          navigate(redirect);
        } else toast.error('Falha de comunicação com o servidor');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          if (formRef.current) formRef.current.setErrors(errors);
          toast.error(err.message);
        } else if (err instanceof Error) {
          toast.error(err.message);
        } else {
          const appError = err as AppError;
          toast.error(appError.message);
        }
        dispatch(signFailure());
      } finally {
        setLoading(false);
      }
    },
    [dispatch],
  );

  return (
    <>
      <img style={{ caretColor: 'transparent' }} src={logo} alt="RPC" />
      <h4>RPC | VAMOS JUNTOS</h4>
      <Form ref={formRef} onSubmit={handleSubmit} autoComplete="off">
        <Input name="login" placeholder="Login" icon={<FiUser />} />
        <Input
          name="senha"
          type="password"
          placeholder="Senha"
          icon={<FiKey />}
        />
        <ButtonLink to="/esqueceusenha" color="primary" size="sm">
          Esqueceu sua senha?
        </ButtonLink>

        <Button color="primary" type="submit" disabled={loading}>
          {loading ? 'ENTRANDO ...' : 'ENTRAR'}
        </Button>
      </Form>
    </>
  );
}
